import { Subject } from 'rxjs';

function storedOwner(): string {
  try { return String(JSON.parse(localStorage.getItem('user') || 'null')?._id || ''); } catch { return ''; }
}
let owner = storedOwner();
let epoch = 0;
export const accountChanges = new Subject<void>();
export const accountOwner = () => owner;
export const accountEpoch = () => epoch;

export function switchAccount(nextOwner: string, force = false): void {
  if (!force && owner === nextOwner) return;
  const previousOwner = owner;
  owner = nextOwner;
  epoch++;
  try {
    for (const key of Object.keys(localStorage)) {
      if ((key.startsWith('dietology:diet-draft:') && (!key.startsWith('dietology:diet-draft:v2:') ||
          !previousOwner || key.startsWith(`dietology:diet-draft:v2:${previousOwner}:`))) ||
          key.startsWith('dietology.publicDietPassword.')) localStorage.removeItem(key);
    }
  } catch { /* Storage may be unavailable; in-memory data is still cleared. */ }
  accountChanges.next();
}
